"use strict";

var _regeneratorRuntime = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yupResolver = void 0;

var react_hook_form_1 = require("react-hook-form");

var parseErrorSchema = function parseErrorSchema(error, validateAllFieldCriteria) {
  return Array.isArray(error.inner) && error.inner.length ? error.inner.reduce(function (previous, _ref) {
    var path = _ref.path,
        message = _ref.message,
        type = _ref.type;
    var previousTypes = previous[path] && previous[path].types || {};
    var key = path || type;
    return Object.assign(Object.assign({}, previous), key ? _defineProperty({}, key, Object.assign(Object.assign({}, previous[key] || {
      message: message,
      type: type
    }), validateAllFieldCriteria ? {
      types: Object.assign(Object.assign({}, previousTypes), _defineProperty({}, type, previousTypes[type] ? [].concat(_toConsumableArray([].concat(previousTypes[type])), [message]) : message))
    } : {})) : {});
  }, {}) : _defineProperty({}, error.path, {
    message: error.message,
    type: error.type
  });
};

var yupResolver = function yupResolver(schema) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    abortEarly: false
  };
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, context) {
      var validateAllFieldCriteria,
          parsedErrors,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              validateAllFieldCriteria = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
              _context.prev = 1;

              if (options.context && process.env.NODE_ENV === 'development') {
                // eslint-disable-next-line no-console
                console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead");
              }

              _context.next = 5;
              return schema.validate(values, Object.assign(Object.assign({}, options), {
                context: context
              }));

            case 5:
              _context.t0 = _context.sent;
              _context.t1 = {};
              return _context.abrupt("return", {
                values: _context.t0,
                errors: _context.t1
              });

            case 10:
              _context.prev = 10;
              _context.t2 = _context["catch"](1);
              parsedErrors = parseErrorSchema(_context.t2, validateAllFieldCriteria);
              return _context.abrupt("return", {
                values: {},
                errors: react_hook_form_1.transformToNestObject(parsedErrors)
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.yupResolver = yupResolver;